import React, { useEffect, useState } from "react";
import { TfiClose } from "react-icons/tfi";
import { LiaLinkSolid } from "react-icons/lia";
import { AiOutlineCaretDown } from "react-icons/ai";
import { MdDoNotDisturbOn } from "react-icons/md";
import "./style.css";
import CustomBottomSheet from "../CustomBottomSheet";
import FloatingTextInput from "../../../../components/FloatingInput";
import UploadImageService from "../../uploadImageService/index";
import { InteractionData } from "../../interaction.interface";
import { Chance } from "chance";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { saveInteractionAPI } from "../../../../services/record.service";
import { toast } from "react-toastify";
import {
  Txt_Logo,
  linkoption_MA,
  linkoption_Yoli,
  linkoption_Zyia,
  linkoption_default,
  Linkoption,
} from "../../../../assets/icons";
import axios from "axios";

import { setInteractionData } from "../../interaction.actions";
import { callEvent } from "../../../../services/main.service";
import {
  getBrandColor,
  REGISTRATION_PARTNER_CO_COLOR,
} from "../../../../utils/brand.util";

const validUrl =
  /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
const chance = new Chance();

const AddLink = (props: any) => {
  const dispatch = useAppDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { language, client } = getUserData();

  const { configurationData } = getLiveMainData();
  const { joinWithAttendeeData, joinData, hostTime, createStreamData } =
    getLiveMainData();
  const { interactionData } = getInteractions();

  const addLinkBrandColor =
    client === "partner.co" ? REGISTRATION_PARTNER_CO_COLOR : getBrandColor(client);
  const { handleUploadImageToS3, imageURL, iShowSpinner } =
    UploadImageService();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLinkOption, setSelectedLinkOption] = useState("J");
  const [selectedIcon, setSelectedIcon] = useState<any>(linkoption_MA);
  const [selectedLinkName, setSelectedLinkName] = useState<any>("Add link");
  const [linkTitle, setLinkTitle] = useState<any>("");
  const [userLink, setUserLink] = useState<any>("");
  const [isShowTitle, setIsShowTitle] = useState(true);
  const [interactionDataArray, setInteractionDataArray] = useState<
    InteractionData[]
  >([]);

  // const setLinkOptions=(selectedLinkOption:any)=>{
  //     switch (selectedLinkOption) {
  //         case 'A':

  //             break;

  //         default:
  //             break;
  //     }
  // }


  const checkBrandOptions = (client: any) => {
    // console.log(client);
    switch (client) {
      case "marketamerica": {
        return linkoption_MA;
      }
      case "zyiaactive": {
        return linkoption_Zyia;
      }
      case "beyondslim": {
        return linkoption_Zyia;
      }
      case "Yoli": {
        return linkoption_Yoli;
      }
      case "Verb": {
        return linkoption_default;
      }
      case "Hussle": {
        return linkoption_default;
      }
      case "Sound Concepts": {
        return Linkoption;
      }

      case "Sound Concepts Demo": {
        return Linkoption;
      }
      default:
        return linkoption_default;
    }
  };

  const checkBrandIconColor = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#4C4B4B] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#1593D6] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#1593D6] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#1593D6] dark:checked:after:bg-[#1593D6] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#1593D6" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
      }
      case "zyiaactive": {
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#4C4B4B] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#3e2a52] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#3e2a52] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#3e2a52] dark:checked:after:bg-[#3e2a52] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#3e2a52" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
      }
      case "beyondslim": {
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#4C4B4B] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#3e2a52] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#3e2a52] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#4C4B4B] dark:checked:after:bg-[#4C4B4B] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#3e2a52" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
      }
      case "Yoli": {
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#d49830] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#d49830] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#d49830] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#d49830] dark:checked:after:bg-[#d49830] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#d49830" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
      }
      case "Verb": {
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#555555] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#555555] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#555555] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#555555] dark:checked:after:bg-[#555555] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#555555" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
      }

      default:
        return (
          <input
            className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#555555] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#555555] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#555555] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-[#555555] dark:checked:after:bg-[#555555] dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
            type="checkbox"
            role="switch"
            style={{
              background: isShowTitle ? "#555555" : "#392276",
            }}
            id="flexSwitchCheckDefault01"
            // value={isShowTitle}
            onChange={() => {
              setIsShowTitle(!isShowTitle);
            }}
          />
        );
    }
  };

  useEffect(() => {
    // fetchOGIcon()
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }
  }, []);

  useEffect(() => {
    // console.log("selected Option===>", selectedLinkOption);
  }, [selectedLinkOption]);

  useEffect(() => {
    // console.log("test======>Interaction", interactionData);
  }, [interactionData]);

  useEffect(() => {
    // console.log("test======>InteractionArray", interactionData);
  }, [interactionDataArray]);

  const isUrl = (s: any) => {
    // var regexp = http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$
    if (linkTitle != "") {
      const pattern = new RegExp( // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return pattern.test(s);
    } else {
      return true;
    }
  };

  // useEffect(()=>{
  //    // console.log("Interaction DataObject===>",interactionObj)
  // },[])

  function lowerCareFirstLetter(string: any) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  const addInteractionDataToArray = () => {
    var data = {
      attributes: {
        action: linkTitle,
        type: "link",
        label: userLink,
        price: "",
        description: "",
        isLinkedToStore: false,
        shouldShow: true,
        labelVisible: isShowTitle,
        thirdPartyUsername: "",
      },
      style: {
        style_type: selectedLinkOption == "J" ? "photo" : "social",
        pulse_animation: false,
        opacity: 1,
        ...(selectedLinkOption == "J" && { thumbnail_url: "https://d1996akzrxebcx.cloudfront.net/assets/linkoption_default.6cc6d58e0217fc393fdeeffcf98cb31d.svg" }),
      },
      center_x: 50,
      center_y: 50,
      rotation_angle: 0,
      start: 0,
      end: 5,
      height_max: 100,
      height_pc: 8,
      width_max: 100,
      width_pc: 8,
      interaction_id: chance.guid(),
      interaction_type: selectedLinkOption == "J" ? "link" : "social",
      interaction_subtype: "other",
      interaction_icon: selectedLinkName,
      featured: false,
    };

    var resp = createStreamData;

    if (
      resp &&
      resp["metadata"] &&
      resp["metadata"]["attendees"] &&
      resp["metadata"]["attendees"].filter(
        (p: { role: string }) => p.role == "host"
      )
    ) {
      var hostInfo = resp["metadata"]["attendees"].filter(
        (p: { role: string }) => p.role == "host"
      )[0];

      callEvent([
        {
          event_data: {
            attendee_email: hostInfo["email"],
            attendee_first: hostInfo["given_name"],
            attendee_id: hostInfo["attendee_id"],
            attendee_role: "attendee",
            attendee_last: hostInfo["family_name"] + " (host)",
            client_id: hostInfo.attendee_id.split("|")[0],
            stream_id: joinWithAttendeeData["stream_id"],
            stream_instance_id: hostInfo["stream_instance_id"],
            user_id: hostInfo.attendee_id,
            interaction_id: data.interaction_id,
            interaction_type: data.attributes.type,
            interaction_label: data.attributes.label,
            interaction_action: data.attributes.action,
            interaction_imageUrl: data.style.thumbnail_url,
            elapsed_seconds: hostTime,
            date: new Date().toUTCString(),
          },
          event_type: "interaction_created",
        },
      ]);
    }

    setInteractionDataArray((prevArray) => [...prevArray, data]);

    setTimeout(() => {
      setSelectedLinkOption("");
      setSelectedLinkName("");
      props.handleCloseClick(true);
    }, 200);
  };

  // useEffect(()=>{
  //     setTimeout(() => {
  //         addInteractionDataToArray()
  //     }, 1000);
  // },[])

  useEffect(() => {
    saveInteractionAPI(
      configurationData?.stream_id,
      interactionDataArray
      // interactionDataArray.filter(
      //   (data: any) => data.attributes.shouldShow === true
      // )
    );
    dispatch(setInteractionData(interactionDataArray));
    // console.log("InteractionArray====>", interactionDataArray);
  }, [interactionDataArray]);

  const toggleSheet = () => {
    setIsOpen(!isOpen);
  };

  //      const fetchUrlData= async (url:any)=> {
  //         const CORS_PROXY_URL = "https://cors-anywhere.herokuapp.com/";
  //         const TARGET_URL = "https://www.google.com";
  //         try {
  //             const headers = {
  //                 'Access-Control-Allow-Origin': '*',
  //                     'Access-Control-Allow-Headers': '*',
  //               };
  //             const response:any = await axios.get(`${CORS_PROXY_URL}${TARGET_URL}`);
  //           const html = await response.text();

  //         } catch (error) {
  //           console.error("Error fetching URL data:", error);
  //           return null;
  //         }
  //       }

  //       const fetchOGIcon=()=>{

  //       fetchUrlData('https://www.facebook.com/')
  //   .then((data:any) => {
  //    // console.log("Title:", data?.title);
  //    // console.log("Icon:", data?.icon);
  //   });
  // }
  return (
    <div className="relative w-full">
      <div
        className="h-full w-full flex flex-col "
        style={{ backgroundColor: "#181818" }}
      >
        <div
          className="overflow-y-auto containerbottomSheet"
          style={{ height: "85%" }}
        >
          <div className="flex w-full justify-between px-3 h-10 items-center">
            <div className="h-2.5 w-2.5"></div>
            <TfiClose
              color="#DEDEDE"
              size={20}
              cursor="pointer"
              onClick={() => {
                props.handleCloseClick(false);
              }}
            />
          </div>
          <div className="flex px-3 mt-2.5">
            <div className="flex h-9 w-9 items-center justify-center bg-[#222324] rounded-md">
              <LiaLinkSolid color="#ffffff" size={20} cursor="pointer" />
            </div>
            <div>
              <span className="text-[#DEDEDE] text-[26px] ml-2.5 ">
                {language["add_link"]}
              </span>
            </div>
          </div>
          <div className="px-3 mt-2.5">
            <div>
              <span className="text-[#DEDEDE] text-sm">
                {language["add_links"]}{" "}
              </span>
            </div>
            {/* <div>
                            <span className="text-[#DEDEDE] text-sm">social media and instant messengers. </span>
                        </div> */}
          </div>
          <div style={{ height: 200 }}>
            <div className="border-t-[1px] border-b-[1px] border-[#414141] py-2 bg-[#222324] mt-2.5">
              <div
                className={`flex ml-3 ${
                  selectedLinkOption == "" ? "border-b-[0px]" : "border-b-[1px]"
                } border-[#414141] ${
                  selectedLinkOption == "" ? "pb-0" : "pb-2"
                } cursor-pointer`}
                onClick={toggleSheet}
              >
                <span
                  style={{ color: addLinkBrandColor }}
                  className=" text-base mr-2"
                >
                  {language["link_type"]}
                </span>
                <AiOutlineCaretDown
                  color={addLinkBrandColor}
                  size={20}
                  cursor="pointer"
                  style={{ marginTop: 3 }}
                />
              </div>
              {selectedLinkOption != "" && (
                <>
                  {selectedLinkOption == "" && (
                    <div className="flex ml-3  pt-2 ">
                      <span className="text-[#BCC3C8] text-base mr-2">
                        i.e. social, messengers, text link
                      </span>
                    </div>
                  )}

                  {selectedLinkOption != "" && (
                    <div className="flex w-full justify-between items-center py-2 cursor-pointer ml-3 ">
                      <div className="flex pt-2">
                        <img
                          src={checkBrandOptions(client)}
                          alt="Icon"
                          height={25}
                          width={25}
                          className="mr-3"
                        />
                        <span className="text-[#FFFFFF] text-base mr-2">
                          {selectedLinkName}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="ml-[30px]  pt-2 ">
                    <span className="text-[#BCC3C8] text-[12px]  px-1">
                      {language["link"]}
                    </span>
                    <input
                      id="floating_standard"
                      className={`block h-full w-full text-sm bg-transparent border-0 border-b border-[#414141] appearance-none focus:outline-none focus:ring-0 peer text-white px-1 pb-3 mt-1`}
                      value={linkTitle}
                      onChange={(e) => {
                        setLinkTitle(e.target.value);
                      }}
                    />
                    {/* {!isUrl(linkTitle)&&<p className="text-[#DA414A] text-[11px]">{language['invalid_url']}</p>} */}
                  </div>

                  <div className="ml-[30px]  pt-3 ">
                    <span className="text-[#BCC3C8] text-[12px]  px-1">
                      {language["title"]}
                    </span>
                    <input
                      id="floating_standard"
                      className={`block h-full w-full text-sm bg-transparent border-0 border-b border-[#414141] appearance-none focus:outline-none focus:ring-0 peer text-white px-1 pb-3 mt-1`}
                      value={userLink}
                      onChange={(e) => {
                        setUserLink(e.target.value);
                      }}
                    />
                  </div>
                  {selectedLinkOption != "" && (
                    <>
                      <div className="flex  justify-between items-center  cursor-pointer  pr-2.5 pl-2.5  "></div>
                      <div className="border-b-[1px] border-[#414141]  ml-[30px]"></div>

                      {/* <div className="ml-[30px]  pt-3 ">
                            <span className="text-[#BCC3C8] text-[12px]  px-1">Title</span>
                            <input
                                id="floating_standard"
                                className={`block h-full w-full text-sm bg-transparent border-0 border-b border-[#414141] appearance-none focus:outline-none focus:ring-0 peer text-white px-1 pb-3 mt-1`}
                            />
                        </div> */}

                      <div className="ml-[30px]  pt-3 pb-3 pl-3 pr-3 bg-[#2D2C2C] mb-3 mr-3 mt-3 rounded">
                        <span className="text-[#DEDEDE] text-sm">
                          {language["preview"]}{" "}
                        </span>
                        <div
                          className="flex pt-2 pb-2 pl-2 pr-2 bg-[#ffffff] rounded-lg"
                          id={"previewContainer"}
                        >
                          {selectedLinkOption == "J" ? (
                            <img
                              src={
                                imageURL == ""
                                  ? checkBrandOptions(client)
                                  : imageURL
                              }
                              alt="Icon"
                              style={{ height: 68, width: 68 }}
                              className="mr-5"
                            />
                          ) : (
                            <img
                              src={selectedIcon}
                              alt="Icon"
                              height={68}
                              width={68}
                              className="mr-5"
                            />
                          )}
                          <div className="flex-col ">
                            {isShowTitle && (
                              <div
                                className="text-[#000000] text-[16px] font-[500]"
                                style={{
                                  marginTop: 20,
                                  width:
                                    document.getElementById("previewContainer")
                                      ?.offsetWidth! - 100,
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                }}
                              >
                                {userLink}
                              </div>
                            )}
                            {/* <div
                              className="text-[#000000] text-[16px] font-[500]"
                              style={{
                                marginTop: isShowTitle ? 0 : 20,
                                width:
                                  document.getElementById("previewContainer")
                                    ?.offsetWidth! - 100,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {linkTitle}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {selectedLinkOption == "J" && (
                    <div className="flex ml-[30px]   mt-2 mb-2">
                      {!iShowSpinner && (
                        <label
                          onChange={(e: any) => {
                            // console.log("eeeeeee", e?.target?.files);
                            let obj = {
                              ACL: "public-read",
                              Body: e?.target?.files![0],
                              Bucket: "corejs-videos-processed",
                              ContentType: e?.target?.files![0].type,
                              Key: e?.target?.files![0].name,
                            };

                            handleUploadImageToS3(obj);
                          }}
                          htmlFor="formId"
                        >
                          <input
                            name=""
                            type="file"
                            accept="image/*"
                            id="formId"
                            hidden
                          />
                          <span
                            style={{ color: addLinkBrandColor }}
                            className="text-sm mr-2 cursor-pointer"
                          >
                            <u>{language["upload_image"]}</u>
                          </span>
                        </label>
                      )}
                      {iShowSpinner && (
                        <>
                          <span className="text-[#B59EFF] text-sm mr-2 cursor-pointer">
                            {language["please_wait"]}
                          </span>
                          <div className="loader"></div>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {selectedLinkOption != "" && (
          <div className="flex w-full items-center justify-center px-14 mb-5 absolute bottom-[20px]">
            <div
              style={{
                backgroundColor:
                  linkTitle != "" && isUrl(linkTitle) ? addLinkBrandColor : "",
              }}
              className={`flex w-full items-center justify-center border-[1px] border-[#414141] rounded-full py-1 cursor-pointer`}
              onClick={() => {
                linkTitle != "" && isUrl(linkTitle) && userLink
                  ? addInteractionDataToArray()
                  : toast("Missing URL or Title", {
                      position: "top-right",
                      autoClose: 2000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
              }}
            >
              <span
                style={{
                  color:
                    linkTitle != "" && isUrl(linkTitle) ? "white" : "#555555",
                }}
                className={`text-lg font-semibold `}
              >
                {language["add"]}
              </span>
            </div>
          </div>
        )}
      </div>
      <div
        className={`absolute w-full  ${
          isOpen ? "pointer-events-auto" : "pointer-events-none"
        } h-[91%] bottom-0  overflow-y-auto containerbottomSheet`}
      >
        <CustomBottomSheet
          isOpen={isOpen}
          toggleSheet={toggleSheet}
          selectedType={(data: any) => {
            setSelectedLinkOption(data);
          }}
          selectedName={(name: any) => {
            setSelectedLinkName(name);
          }}
          selectedIconName={(icName: any) => {
            setSelectedIcon(icName);
          }}
        />
      </div>
    </div>
  );
};

export default AddLink;
